import { BaseClient } from './base-client';
import { Job, JobLog, CreateJobRequest, UpdateJobRequest, TriggerJobResponse, CronApiConfig } from './types';

export class JobsClient extends BaseClient {
  constructor(config: CronApiConfig) {
    super(config);
  }

  /**
   * Get all jobs
   */
  public async getAll(): Promise<Job[]> {
    return this._get<Job[]>('/api/jobs');
  }

  /**
   * Get a job by ID
   */
  public async getById(id: number): Promise<Job> {
    return this._get<Job>(`/api/jobs/${id}`);
  }

  /**
   * Create a new job
   */
  public async create(job: CreateJobRequest): Promise<Job> {
    return this._post<Job>('/api/jobs', job);
  }

  /**
   * Update an existing job
   */
  public async update(job: UpdateJobRequest): Promise<Job> {
    return this._put<Job>(`/api/jobs/${job.id}`, job);
  }

  /**
   * Delete a job
   */
  public async delete(id: number): Promise<void> {
    return this._delete<void>(`/api/jobs/${id}`);
  }

  /**
   * Get logs for a specific job
   */
  public async getLogs(id: number): Promise<JobLog[]> {
    return this._get<JobLog[]>(`/api/jobs/${id}/logs`);
  }

  /**
   * Manually trigger a job
   */
  public async trigger(id: number): Promise<TriggerJobResponse> {
    return this._post<TriggerJobResponse>(`/api/jobs/${id}/trigger`);
  }

  /**
   * Get all logs across all jobs
   */
  public async getAllLogs(): Promise<JobLog[]> {
    return this._get<JobLog[]>('/api/logs');
  }
}
